import React, { createContext, useContext, ReactNode, useState } from 'react';

interface OmnisearchContextType {
  omnisearch: string | null;
  hasUserSetOmnisearch: boolean;
  setOmnisearch: (value: string) => void;
}

const OmnisearchContext = createContext<OmnisearchContextType | undefined>(undefined);

interface OmnisearchProviderProps {
  children: ReactNode;
  initialOmnisearch?: string;
}

export const OmnisearchProvider: React.FC<OmnisearchProviderProps> = ({ children, initialOmnisearch }) => {
  const [omnisearch, setOmnisearchInternal] = useState<string | null>(initialOmnisearch ?? null);
  const [hasUserSetOmnisearch, setHasUserSetOmnisearch] = useState(false);
  const setOmnisearch = React.useCallback((value: string) => {
    setOmnisearchInternal(value);
    setHasUserSetOmnisearch(true);
  }, []);

  const contextValue = React.useMemo(() => ({ omnisearch, setOmnisearch, hasUserSetOmnisearch }), [omnisearch, setOmnisearch, hasUserSetOmnisearch]);

  return (
    <OmnisearchContext.Provider value={contextValue}>
      {children}
    </OmnisearchContext.Provider>
  );
};

export const useOmnisearchContext = (): OmnisearchContextType | undefined => {
  return useContext(OmnisearchContext);
}; 